import React from "react";
import SettingLayout from "../SettingLayout";

const manageFeautureIndex = () => {
  return (
    <>
      <SettingLayout hideBtn title="Manage Feature"></SettingLayout>
    </>
  );
};

export default manageFeautureIndex;
